
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { APPSETTING } from '../main';


export const CLOSEDDATA = [{startdate:"2026-05-01T14:00:00", enddate:"2026-05-01T19:00:00"}, 
  {startdate:"2026-05-02T00:00", enddate:"2026-05-04T00:00"}];

export const TIMEDATA = ("09:00,10:00,11:00,12:00,13:00,14:00,15:00,16:00,17:00").split(",");
export const DAILYAVAILABLETIME = [
    {day:"Monday", time:TIMEDATA, dow:1},
    {day:"Tuesday", time:TIMEDATA, dow:2},
    {day:"Wednesday", time:TIMEDATA, dow:3},
    {day:"Thursday", time:TIMEDATA, dow:4},
    {day:"Friday", time:TIMEDATA, dow:5},
    {day:"Saturday", time:TIMEDATA, dow: 6},
    {day:"Sunday", time:TIMEDATA, dow: 0},
    
];

export const WAITINGGIF =  "<img src=\"/css/whatsappapi/waiting.gif\" style=\"width:23px;\">";

export async function getdata(payload:any, url="/appdata") {
    let token = APPUSER.user.token;
  
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    if (response.status == 403) {      
      localStorage.setItem(APPSETTING.appname + "user", null);
      document.location.href = "/login";
      return null;
    }
    const data = await response.json();
    return data; 
}

export async function getdatanoauth(payload:any, url="/appdatanoauth") {
    //let token = APPUSER.user.token;
    payload.filter._adminuserid = APPSETTING.adminuserid;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload)
    });

    console.log("status: " + response.status);
    const data = await response.json();

    if (response.status != 200) {
      if (data.message && data.message.indexOf("cache refresh") >= 0) {
        throw new Error("Cache is reloading. Please wait.");
      }
    }

    return data; 
}

export async function updatedata(payload:any, url="/updateappdata") {
    let token = APPUSER.user?.token;
    //console.log("toke" + token);
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    return data; 
}

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export const formatdate = (date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = MONTHS[date.getMonth()];
  const year = date.getFullYear();
  return `${month} ${day} ${year}`;
};

export const getdate = (datestr) => {
  if (!datestr) return "";
  datestr = datestr.split(" ");

  const day = datestr[1];
  let month = MONTHS.findIndex(item => item == datestr[0]) + 1;
  month = (month < 10 ? "0" : "") + month;
  const year = datestr[2];
  datestr = year + "-" + month + "-" + day;
  return {datestr:datestr, date:new Date(datestr)}
};

// creation time of a record from its mongo _id (first 8 hex chars are seconds since epoch), as an iso string
export const getidtimestamp = (id: string) => new Date(parseInt(id.substring(0, 8), 16) * 1000).toISOString();


export async function deletedata(payload:any, oncomplete) {
    let token = APPUSER.user.token;
  
    const response = await fetch("/deleteappdata", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    });
    if (response.status == 403) {      
      localStorage.setItem(APPSETTING.appname + "user", null);
      document.location.href = "/login";
      return null;
    }
    const data = await response.json();
    if (oncomplete) {
      oncomplete();
    }
    return data; 
}

// export async function sendwhatsappmessage(params) {
//   let phonenumber = params.receiverphonenumber.split(",");
//   let message = params.message;
//   let processdata = [];
//   for (let i=0; i < phonenumber.length;i++) {
//     const response = await fetch("http://localhost:3000/sendmessage", {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//         'Authorization': 'Bearer xxx'
//       },
//       body: JSON.stringify({
//         senderphonenumber: params.senderphonenumber, 
//         receiverphonenumber: phonenumber[i], 
//         message: message
//       })
//     });
//     const data = await response.json();
//     processdata.push({phonenumber:phonenumber[i], response:data});
//   }
// }

export async function sendwhatsappmessage(params) {
  let receiverphonenumber = params.receiverphonenumber;
  let message = params.message;
  let senderphonenumber = params.senderphonenumber;
  let token = APPUSER.user.token;

  const response = await fetch("/sendwhatsappmessage", {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
      },
      body: JSON.stringify({
        senderphonenumber: senderphonenumber, 
        receiverphonenumber: receiverphonenumber, 
        message: message,
        senderid: params.senderid
      })
    });
    const data = await response.json();
    return data;
}

export async function getchiefofstaffstatus() {
  const token = APPUSER?.user?.token;
  if (!token) return { zoho: 'demo' };
  try {
    const response = await fetch('/chiefofstaffstatus', {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    if (!response.ok) return { zoho: 'demo' };
    return response.json();
  } catch {
    return { zoho: 'demo' };
  }
}

export async function askchiefofstaff(question: string) {
  const token = APPUSER.user.token;
  const response = await fetch('/chiefofstaffask', {
    method: 'POST',
    headers: {
      'Content-Type':  'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({ question }),
  });
  if (response.status === 403) {
    localStorage.setItem(APPSETTING.appname + 'user', null);
    document.location.href = '/login';
    return null;
  }
  return response.json();
}

export async function getwhatsappqr(phonenumber) {
  let token = APPUSER?.user ? APPUSER.user.token : "";

  const response = await fetch("/whatsappqr", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    },
    body: JSON.stringify({phonenumber:phonenumber})
  });
  const data = await response.json();
  return data;
}


 export const sendwhatsappmessageapi = async (params) => {
      let message = params.message;
      let receiverphonenumber = params.receiverphonenumber;
      let payload = {
          senderid:"6a44a310a8bbcb01c002be7d",
          senderphonenumber: "919623078401",
          receiverphonenumber:receiverphonenumber,
          message: message
      };
      console.log(payload);
      if (payload.receiverphonenumber.find (item => { return item.phonenumber.match(/[^0-9]+/gi);})) {
        alert("invalid receiver phone number");
          return;
      }
      let res = await fetch('https://senddit.in/sendwhatsappmessage', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyaWQiOiI2YTEyOGFjZTljYjc0ODBmZDJlMzU5NjkiLCJlbWFpbCI6InZpcmFqLnBhdGlsK3dhQGdtYWlsLmNvbSIsImFkbWludXNlcmlkIjoiNmEwNDNhNzNlZjk2NGU2N2UxYzc3ZWMwIiwiYXBwbmFtZSI6IndoYXRzYXBwYXBpIiwiaWF0IjoxNzgyNjM1ODQzLCJleHAiOjE4MTQxNzE4NDN9.RDK4ac_v-trgizwKdPamdzO1hd1BU5Lxbah_qFZwLJk'
        },
        body: JSON.stringify(payload),
      });
      res = await res.json();
      console.log(res);
    };
   

export const getbundledata = async() => {
  const adminuserid = window.APPUSER?.user?.token ? window.APPSETTING.adminuserid : params.get('adminuserid');
  let data = await getdatanoauth({ zohodatatype: 'bundles', _adminuserid: adminuserid }, '/zohodatanoauth');
  data = data.data;
  let zohotagdata = await getdata({filter:{datatype:"zohotagdata"}});
  let bunresolveddata = [];
  let tmp = [];
  for (let i=0; i < data.length;i++ ) {
    let d = data[i];
    let bunresolved = zohotagdata.find((item) =>  {
      return item.bundle_id == d.bundle_id;
    });
    if (bunresolved?.status == "resolved") {
      bunresolveddata.push({...d, ...bunresolved});
    } else if (bunresolved) {
      tmp.push({...d, ...bunresolved});
    } else {
      tmp.push(d);
    }
  }
  data = tmp;
  return {data:data, bunresolveddata:bunresolveddata};
};


export const uploadfiledata = async (payload) => {
  try {
    const formdata = new FormData();

    for (let key in payload) {
      let value = payload[key];

      if (key === "files" && Array.isArray(value)) {
        // Unpack every actual File/Blob object from the array wrapper
        for (let i = 0; i < value.length; i++) {
          formdata.append("files", value[i]);
        }
      } else if (value !== null && value !== undefined) {
        // Appends standard fields like _adminuserid, _userid, appname, etc. cleanly
        formdata.append(key, value);
      }
    }

    let token = APPUSER?.user ? APPUSER.user.token : "";

    const response = await fetch('/updatefiledata', {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + token
      },
      body: formdata
    });
    
    return await response.json();
  } catch (error) {
    console.error("uploadfiledata error:", error);
    return { success: false, error: error };
  }
};
